'use strict';

var React = require('react');

var SvgContentMinor = function SvgContentMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-6Zm3 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 9a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm13-1a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h2Zm-4.388-8.435a1 1 0 0 1 1.8-.012l1.479 3.005a1 1 0 0 1-.898 1.442h-5.993c-.862 0-1.313-1.019-.74-1.664l.69-.996a.993.993 0 0 1 1.5 0l.418.51a.5.5 0 0 0 .828-.142l.916-2.143Z"
  }));
};

exports.SvgContentMinor = SvgContentMinor;
